import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import Button from "sushiweb/Button";
import AddEdit from "sushiweb/Icons/all/AddEdit";
import Delete from "sushiweb/Icons/all/Delete";
import ActiveTabFields from "../../../constants/FCTaskList/FCTaskActiveList.json";
import PastTabFields from "../../../constants/FCTaskList/FCTaskPastList.json";
import {
  Form_Action,
  editFormState as initialFormState,
} from "../../../constants/FleetCoachTask";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import SuccessMessages from "../../../constants/SucessMessages.json";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import * as FleetCoachTaskActions from "../../../store/actions/FleetCoachTask";
import * as UserActions from "../../../store/actions/User";
import * as userActions from "../../../store/actions/User";
import { getPath, isValNull } from "../../../utils";
import FCTaskCreation from "../../../views/FleetCoachTask/FCTaskCreation";
import BlankState from "../../Common/BlankState";
import NoFooterModal from "../../Common/NoFooterModal";
import Permission from "../../Common/Permission";
import SaveModal from "../../Common/SaveModal";
import Table from "../../Common/Table";
import { toLocaleDateString, generateFileName } from "../../../utils";
import { Link } from "../../../constants/assets/containers";

const FCTaskList = (props) => {
  const {
    taskList,
    isActiveTab,
    deleteFleetCoachTask,
    updateFleetCoachTask,
    setUploadedFileName,
    setUploadedVideoName,
    setStatus,
  } = props;

  const [initialState, setInitialState] = useState(initialFormState);
  const [formError, setFormError] = useState("");
  const allActions = MenuActionsMappings[MenuNames.FLEET_COACH_TASK];
  const [modalState, setModalState] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(true);

  const handleActionClick = (action, task) => {
    setModalState(action);
    setInitialState({
      ...task,
      task_type: "AWARNESS_TASK",
      start_date: toLocaleDateString(task.start_date),
      end_date: toLocaleDateString(task.end_date),
    });
  };

  const toggleModal = () => {
    setConfirmModalOpen(!confirmModalOpen);
    setModalState(null);
  };

  const validateDetails = () => {
    let err = "";
    for (let key in initialState) {
      if (key === "csv_file" || key === "audio_file") continue;
      if (isValNull(initialState[key])) {
        err = `${key.split("_").join(" ")} is the mandatory field`;
        break;
      }
    }
    return err;
  };

  const handleSubmitButton = () => {
    let errorMsg = validateDetails();
    if (errorMsg.length === 0) {
      updateFleetCoachTask(initialState).then(() => {
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        });
        setTimeout(() => window.location.reload(), 500);
      });
      setModalState("");
    } else {
      setFormError(errorMsg);
    }
  };

  const handleCancelButton = () => {
    setInitialState(initialFormState);
    setModalState("");
    setUploadedFileName("");
    setUploadedVideoName("");
  };

  const handleDeleteButton = () => {
    deleteFleetCoachTask({ task_id: initialState?.task_id }).then(() => {
      setTimeout(() => window.location.reload(), 2000);
    });
  };

  const getModalButtons = (action) => {
    return (
      <FlexContainer>
        <Button
          className="flex justify-center"
          appearance="outline"
          onClick={handleCancelButton}
        >
          Cancel
        </Button>
        {action === Form_Action.EDIT ? (
          <Button className="flex justify-center" onClick={handleSubmitButton}>
            Save
          </Button>
        ) : (
          <Button onClick={handleDeleteButton}>Delete</Button>
        )}
      </FlexContainer>
    );
  };

  const getMessage = () =>
    `Confirm if you want to delete the task.  This cannot be undone`;

  const getModal = (type, taskDetails) => {
    switch (type) {
      case Form_Action.EDIT:
        return (
          <NoFooterModal
            header={true}
            heading={`Edit Task`}
            handleClose={toggleModal}
            id="PropertiesFormModal"
            modalButtons={getModalButtons(type)}
          >
            <FCTaskCreation
              initialState={initialState}
              setInitialState={setInitialState}
              setFormError={setFormError}
              formError={formError}
              isEditableModal
            />
          </NoFooterModal>
        );
      case Form_Action.DELETE:
        return (
          <SaveModal
            isVisible={confirmModalOpen}
            handleSubmit={handleDeleteButton}
            handleClose={handleCancelButton}
            heading="Delete Task"
            getMessage={getMessage}
          />
        );
    }
  };

  const getFieldValue = (task, key) => {
    switch (key) {
      case "actions":
        return (
          <FlexContainer>
            <Permission
              requiredPerms={[allActions.FLEET_COACH_TASK_CREATE]}
              notAllowedText="insufficient role"
            >
              <AddEdit
                onClick={() => handleActionClick(Form_Action.EDIT, task)}
                color={variables.blue500}
                className="ml-10 mb-10 edit-icon cursor-pointer"
              />
              <Delete
                onClick={() => handleActionClick(Form_Action.DELETE, task)}
                color={variables.blue500}
                className="ml-10 mb-10 edit-icon cursor-pointer"
              />
            </Permission>
          </FlexContainer>
        );

      case "download":
        return (
          <DownloadAction>
            <Link
              download={generateFileName(task.task_heading, "mp3", "note")}
              href={getPath(task, "audio_file_url", "NA")}
              className={"edit-options cursor-pointer"}
            >
              Note
            </Link>
            <Link
              download={generateFileName(task.task_heading, "csv", "csv")}
              href={getPath(task, "csv_file_url", "NA")}
              className={"edit-options cursor-pointer"}
            >
              CSV
            </Link>
          </DownloadAction>
        );

      default:
        return getPath(task, key, "NA");
    }
  };

  const getTaskDetail = (taskList) => {
    return (
      <Table
        list={taskList}
        getFieldValue={getFieldValue}
        fields={isActiveTab ? ActiveTabFields : PastTabFields}
        wrapContents
      />
    );
  };

  return (
    <React.Fragment>
      <TaskListContainer data-testid="taskListContainer">
        {!isValNull(taskList) ? getTaskDetail(taskList) : <BlankState />}
      </TaskListContainer>
      {modalState && getModal(modalState)}
    </React.Fragment>
  );
};

const TaskListContainer = styled.div`
  border: 0.5px solid ${variables.borderColor};
  box-sizing: border-box;
  border-radius: 0.5rem;
`;

const DownloadAction = styled.div`
  > a:first-child {
    margin-right: 10px;
  }
`;

function mapStateToProps(state) {}

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(userActions.setStatus, dispatch),
    updateFleetCoachTask: bindActionCreators(
      FleetCoachTaskActions.updateFleetCoachTask,
      dispatch
    ),
    deleteFleetCoachTask: bindActionCreators(
      FleetCoachTaskActions.deleteFleetCoachTask,
      dispatch
    ),
    setUploadedFileName: bindActionCreators(
      UserActions.setUploadedFileName,
      dispatch
    ),
    setUploadedVideoName: bindActionCreators(
      UserActions.setUploadedVideoName,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FCTaskList);
